import React, { useState } from "react"
import { FC } from "react"
import { Navbar, Container, Table, Nav } from "react-bootstrap";
import { Coins } from "./coins";
import { categoryImgs } from "../types/Category";
import { AddBtn } from "./add-btn";
import { useMissions } from "../queries/mission-queries";
import { Link, useNavigate } from "react-router-dom";
import { StreakedMission } from "../types/Mission";

export const Missions: FC = () => {
    const { oneshotMissions, repeatingMissions } = useMissions();
    const nav = useNavigate();
    const [activeTab, setActiveTab] = useState<string>('repeat-key');

    const handleSelect = (selectedKey: string | null) => {
        if (selectedKey) {
            setActiveTab(selectedKey);
        }
    };

    return (
        <>
            <Navbar sticky="top" key={'nav-bar'} expand={false} className="bg-body-secondary mb-3">
                <Container fluid>
                    <h2 className="mb-0">Missions</h2>
                </Container>
            </Navbar>
            <Container>
                <Nav variant="tabs" onSelect={handleSelect} defaultActiveKey="repeat-key" className="justify-content-between">
                    <div className="d-flex">
                        <Nav.Item>
                            <Nav.Link eventKey="repeat-key">Repeating</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="oneshot-key">Oneshots</Nav.Link>
                        </Nav.Item>
                    </div>
                    <Link to="/create-mission">
                        <AddBtn />
                    </Link>
                </Nav>
                <Table>
                    <thead>
                        <tr>
                            <th className="text-start">Name</th>
                            <th className="text-end">Reward</th>
                            <th className="text-end">Days left</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {(activeTab === 'oneshot-key' ? oneshotMissions : repeatingMissions).map((mission: StreakedMission, index) => (
                            <tr onClick={() => nav('/missions/' + mission.id)} key={index}>
                                <td className="text-start">{mission.title}</td>
                                <td className="text-end"><Coins coins={mission.reward} fontSize={6} size={11} /></td>
                                <td className="text-end">{mission.daysLeft}</td>
                                <td>
                                    <img
                                        src={categoryImgs[mission.category]}
                                        width="15"
                                        height="15"
                                        className="d-inline-block align-top"
                                        alt={mission.category}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Container>
        </>
    )
}